import Component from "../abstracts/Component";

export default class ShopCategoryComponent extends Component {
  get COMPONENTNAME() {
      return 'ShopCategoryComponent';
  }

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      navDots: '[data-nav-dots]',
      card: '[data-card]',
      content: '[data-content]',
    };
  }

  get CSS() {
    return {
      hidden: '--hidden',
      fourthCase: '--four-cards-case',
    }
  }

  importLibrary() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => { resolve(module) },
        error => { reject(error) }
      );
    })
  }

  readDOM() {
    return {
      main: this.$component.querySelector(this.SELECTORS.main),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      navDots: this.$component.querySelector(this.SELECTORS.navDots),
      cards: Array.from(this.$component.querySelectorAll(this.SELECTORS.card)),
      content: this.$component.querySelector(this.SELECTORS.content),
    }
  }

  render() {
    super.render();

    this.slickInstance = null;
    this.dom = this.readDOM();

    if (!this.dom.main) return;

    this.importLibrary().then(() => {
      this.initCarousel();
    });
  }

  initCarousel() {
    const hasContent = this.dom.content !== null;
    const hasFourCards = this.dom.cards.length === 4;
    this.$component.classList.toggle(this.CSS.fourthCase, hasFourCards);
    const opts = {
      dots: true,
      arrows: true,
      autoplay: false,
      swipeToSlide: !hasFourCards && hasContent,
      centerMode: !hasContent && !hasFourCards,
      slidesToScroll: 1,
      infinite: !hasContent,
      slidesToShow: hasContent ? 2.7 : !hasContent && hasFourCards ? 4 : 3,
      centerPadding: !hasContent && !hasFourCards ? '15%' : '0',
      prevArrow: this.dom.prevArrow,
      nextArrow: this.dom.nextArrow,
      appendDots: this.dom.navDots,
      draggable: !hasFourCards || hasContent,
      rows: 0,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '15%',
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: hasFourCards ? 4 : 3,
            infinite: !hasFourCards,
            centerMode: !hasFourCards,
            centerPadding: !hasFourCards ? '15%' : '0',
          },
        },
      ],
    };
    this.slickInstance = $(this.dom.main).slick(opts);

    if (hasContent) {
      this.slickInstance.on('beforeChange', (evt, slick, curSlide, nextSlide) => {
        if (slick.options.infinite) return;

        // phantom slide, so we start from one
        /*if (nextSlide === 1) {
          this.toggleArrow('prev', false);
        } else if (nextSlide === this.dom.cards.length - 1) {
          this.toggleArrow('next', false);
        } else {
          this.toggleArrow('prev', true);
          this.toggleArrow('next', true);
        }*/
      });
    }

//    this.slickInstance.slick('slickGoTo', 1);
  }

  toggleArrow(which, enable) {
    const toggleElem = elem => {
      elem.classList.toggle(this.CSS.hidden, !enable);
    }

    const arrows = {
      prev: this.dom.prevArrow,
      next: this.dom.nextArrow,
    };

    toggleElem(arrows[which]);
  }
}
